import styled, { keyframes } from 'styled-components';
import { Icon } from 'components/Icon';
import { row } from 'styles/globalStyles';
import { formatDate } from 'utils/date-utils';

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
`;

const InfoBoxSkeleton = function() {
  return (
    <SkeletonStyle>
      <div className="day">
        <div className="skeleton-line date-skeleton" />
        <div className="skeleton-line update-skeleton" />
      </div>
      <div className="location">
        <div className="skeleton-line skeleton-icon" />
        <div className="skeleton-line location-skeleton" />
      </div>
    </SkeletonStyle>
  );
};

const InfoBoxError = function({ onRetry }) {
  return (
    <ErrorStyle>
      <Icon name="AlertCircle" $width={32} $height={32} className="error-icon" />
      <p className="error-message">날씨 정보를 불러오는데 실패했습니다.</p>
      {onRetry && (
        <button type="button" className="retry-button" onClick={onRetry}>
          다시 시도
        </button>
      )}
    </ErrorStyle>
  );
};

export function InfoBox({loading = false, data, error, onRetry}) {
  if (loading) {
    return <InfoBoxSkeleton />;
  }
  
  if (error || !data) {
    return <InfoBoxError onRetry={onRetry} />;
  }

  return <InfoBoxStyle>
    <div className="day">
      <p>오늘 {formatDate(data.aplYmd, 'YYYYMMDD', 'MM.DD (dd)')}</p>
      <span>{formatDate(`${data.aplYmd}${data.aplHour}0000`, 'YYYYMMDDHHmmss', 'A HH:mm')} 업데이트</span>
    </div>
    <div className="location">
      <Icon name="Pin" $width={20} $height={20} />
      <p>{data.lareaNm && data.lareaNm !== '-' ? data.lareaNm : ''} {data.mareaNm} {data.sareaNm}</p>
    </div>
  </InfoBoxStyle>;
}



const InfoBoxStyle = styled.div`
  .day {
    ${row}
    justify-content: space-between;
    align-items: center;

    p {
      color: #252729;
      font-weight: 700;
      font-size: 18px;
      line-height: 1.5;
    }
    span {
      color: #66686b;
      font-size: 14px;
      font-weight: 500;
    }
  }

  .location {
    ${row}
    margin-top: 4px;
    align-items: center;
    gap: 2px;

    p {
      color: #7a7d7f;
      font-size: 16px;
      font-weight: 500;
      line-height: 1.5;
    }
  }
`;

const SkeletonStyle = styled.div`
  .skeleton-line {
    background: linear-gradient(to right, #f6f7f8 8%, #edeef1 18%, #f6f7f8 33%);
    background-size: 400px 100%;
    animation: ${shimmer} 1.2s linear infinite;
    border-radius: 4px;
    height: 16px;
  }

  .day {
    ${row}
    justify-content: space-between;
    align-items: center;

    .date-skeleton {
      width: 150px;
      height: 20px;
    }

    .update-skeleton {
      width: 120px;
      height: 16px;
    }
  }

  .location {
    ${row}
    margin-top: 4px;
    align-items: center;
    gap: 2px;

    .skeleton-icon {
      width: 20px;
      height: 20px;
      border-radius: 50%;
    }

    .location-skeleton {
      width: 180px;
      height: 18px;
      margin-left: 2px;
    }
  }
`;

const ErrorStyle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  
  .error-icon {
    color: #e74c3c;
    margin-bottom: 8px;
  }
  
  .error-message {
    color: #e74c3c;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
  }
  
  .retry-button {
    margin-top: 12px;
    padding: 8px 16px;
    background-color: #e74c3c;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    
    &:hover {
      background-color: #c0392b;
    }
  }
`;